import { useRef } from 'preact/hooks';
import { type JSX } from 'preact';

// This fixes the issue calling onMouseEnter on touch device before onClick on element
// It is done via event processing order 1. onTouchStart, 2. onMouseEnter 3. onClick
export function useMouseEnterWithClick(
	onMouseEnter: JSX.MouseEventHandler<HTMLButtonElement>,
	onClick: JSX.MouseEventHandler<HTMLButtonElement>,
) {
	const isTouchClick = useRef(false);
	const onTouchStart: JSX.TouchEventHandler<HTMLButtonElement> = () => {
		isTouchClick.current = true;
	};
	const handlerOnMouseEnter: JSX.MouseEventHandler<HTMLButtonElement> = (event) => {
		// Do not call mouse enter on touch device
		if (isTouchClick.current) {
			return;
		}

		onMouseEnter(event);
	};
	const handlerOnClick: JSX.MouseEventHandler<HTMLButtonElement> = (event) => {
		isTouchClick.current = false;
		event.preventDefault();
		onClick(event);
	};

	return {
		onTouchStart,
		onMouseEnter: handlerOnMouseEnter,
		onClick: handlerOnClick,
	};
}
